import { compareDesc } from 'date-fns';

export const sortDateWithDateFns = (a, b) => {
  const a1 = new Date(a); 
  const b1 = new Date(b); 
  return compareDesc(a1, b1);
};

export const sortStatusWithBadge = (a, b) => {
  if (a.values.documentStatus < b.values.documentStatus) return -1;
  else if (a.values.documentStatus > b.values.documentStatus) return 1;

  return 0;
};
